<template>
  <div class="locked">
    <div class="locked-header">
      <h1 class="locked-header-text">Upgrade to Professional</h1>
      <div class="locked-byline">
        Upgrade your test to access more data features and consultancy findings.
      </div>
    </div>
    <h1 class="locked-sub-header-text">Professional</h1>
    <bg-icon class="info-icon" name="muscleBrain" />
    <div class="add-holder">
      <div :key="item" v-for="item in items" class="add-item">
        <bg-icon class="add-icon" name="add" />
        {{ item }}
      </div>
    </div>
    <bg-button class="bottom-btn" text="Upgrade" @click="openHelpCrunch" />
  </div>
</template>

<style scoped>
.locked-header-text {
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 10px;
}
.locked-sub-header-text {
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 10px;
}
.bottom-btn {
  margin-bottom: 300px;
}
.info-icon {
  height: 140px;
  width: 140px;
}
.locked-byline {
  font-size: 18px;
  margin-bottom: 40px;
}
.info-holder {
  display: flex;
}
.add-item {
  font-size: 20px;
  padding-bottom: 20px;
  display: flex;
}
.add-icon {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}
</style>

<script>
import BgButton from "@/components/bg-button";
import BgIcon from "@/components/bg-icon";
import BgLogo from "@/components/bg-logo";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "locked",
  components: {
    BgButton,
    BgLogo,
    BgIcon,
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
  },
  data() {
    return {
      items: [
        "Pages",
        "Tags",
        "Three extra consultant findings",
        "Consultant presentation",
      ],
    };
  },
  methods: {
    openHelpCrunch() {
      HelpCrunch("openChat");
      HelpCrunch(
        "typeUserMessage",
        `Hello!  I would like to ask about upgrading essential test ${
          this.testState.name
        } from ${this.testState.company.name} to professional!`
      );
    },
  },
};
</script>
